<template>
  <div class="tag-icon">
    <base-icon :name="icon" />
  </div>
</template>
<script>
export default {
  props: {
    icon: { default: 'painel/users-icon', type: String },
  },
}
</script>
<style lang="scss" scoped>
.tag-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: $neutrallightest;
  color: $neutral;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    height: 24px;
    width: 24px;
  }
}
</style>
